import React from "react";

import { getTranslation } from "../../../../helpers/getLanguage";
import Projects from "../../../Dashboard/tabs/projects/Projects";
import { useTrashProjects } from "../../hooks/useTrashProjects";

const ProjectsGrid = ({
  getTrash,
  projects,
  userStatus,
  userId,
  userFeatures,
  handlePickedProject,
  projectsPicked,
}) => {
  const { handleDeleteProject, handleRestoreProject } = useTrashProjects(getTrash, projects);

  return (
    <div>
      {projects.length ? (
        <Projects
          projects={projects}
          filters={[]}
          handleArchive={(project) => handleRestoreProject(project)}
          handleDelete={(project) => handleDeleteProject(project)}
          isProjectArchived={() => ({})}
          userStatus={userStatus}
          userId={userId}
          projectsReady={false}
          userFeatures={userFeatures}
          handleSelectedProjects={handlePickedProject}
          handleSelectedFolders={() => ({})}
          selectedFolders={[]}
          selectedProjects={projectsPicked}
          canTransfer={false}
        />
      ) : (
        <div className="flex-column report-placeholder">
          <span>{getTranslation("NO_PROJECTS_IN_TRASH")}</span>
          <span>{getTranslation("NO_PROJECTS_MESSAGE")}</span>
        </div>
      )}
    </div>
  );
};

export default ProjectsGrid;
